import { useEffect, useState } from 'react'
import OptimizeService from 'services/Optimize'

let variants = {};

const useVariant = (experimentId) => {
    const [variant, setVariant] = useState(variants[experimentId] || "0");

    useEffect(() => {
        if(variants[experimentId]){
            setVariant(variants[experimentId]);
        } else {
            OptimizeService.getVariant(experimentId).then(response => {
                setVariant(response || "0");

                if(response){
                    variants[experimentId] = response;
                }
            });
        }
    }, []);

    return variant;
}

export default useVariant;
